import {getSubmissions} from '@/containers/E4ImpactProjects/TabSections/Output/filterByEmployees';

/**
 * Survey: PROJECT - BASELINE IMPACT
 * Question: How many people does your business currently employ?
 * 
 * == baseline
 * jobs_t0_total_number
 * 
 * 
 * Survey: PROJECT- FINAL IMPACT
 * Question: How many people does your business employ?
 * 
 * == final
 * jobs_t1_total_number
 * 
 * @param props 
 * @returns 
 */
export const averageNumberOfJobsCreatedPerEntrepreneurTotalCalculation = (props: any) => {
    const positiveSubmissions = getSubmissions(props);

    const totalCount = positiveSubmissions.reduce(
        (acc, {baselineSubmission, finalSubmission}: any) => acc + (
            (Number(finalSubmission.jobs_t1_total_number) || 0) - (Number(baselineSubmission.jobs_t0_total_number) || 0)),
        0
    );

    return (totalCount / positiveSubmissions.length).toFixed(2);
}